import { useBasket } from './use-basket';

export const useIsInBasket = (id) => {
  const [basket, _] = useBasket();
  return basket.items.some((item) => item.id === id);
};
